<script setup lang="ts">
import { TableEntityChangelog, ModalChangelogDetail } from '@widgets/changelog'

import { useCustomerChangelogPage } from '../model/customer-changelog-page.hook'

defineOptions({
  name: 'CustomerChangelogPage',
})

useCustomerChangelogPage()
</script>

<template>
  <TableEntityChangelog />
  <ModalChangelogDetail />
</template>
